import React, { useEffect, useRef } from 'react';
import { extractTitle } from 'scripts/string';
import { __HintTextProps } from './hintText.interface';
import './hintText.style.scss';

const HintText: React.FC<__HintTextProps> = function (props: __HintTextProps) {
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current) contentRef.current.innerHTML = extractTitle(props.value, false);
    }, [props.value]);

    return (
        <div className="ucheck-slp-hint-text">
            <div className="hint-content" ref={contentRef} />
        </div>
    );
};
export default HintText;
